module.exports = __webpack_public_path__ + "static/img/kyc-group.dfe1cf8.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/kyc-group.svg
// module id = Dowg
// module chunks = 1